// @flow
import * as React from 'react';
import CheckEmailModal from 'app/common/react/components/settings/UserSettingsPage/CheckEmailModal';
import ConfirmErasePasswordModal from 'app/common/react/components/Nags/CompromisedAccountNag/ConfirmErasePasswordModal';
import ConnectedAccountSuccessModal from 'app/common/react/components/Nags/CompromisedAccountNag/ConnectedAccountSuccessModal';
import ConnectViewer from 'app/common/react/components/common/ConnectViewer/ConnectViewer';
import NagBanner from 'app/common/react/components/Nags/CompromisedAccountNag/NagBanner';
import PasswordChangeSuccessModal from 'app/common/react/components/settings/UserSettingsPage/PasswordChangeSuccessModal';
import PasswordModal from 'app/common/react/components/settings/UserSettingsPage/PasswordModal';
import SocialNetworkSettingsManager from 'app/common/lib/SocialNetworkSettings';
import type { Viewer } from 'app/packages/pinterest-flow-types/viewer';

type ModalKey =
  | 'changePassword'
  | 'changedPasswordSuccess'
  | 'forgotPassword'
  | 'confirmGoogleConnect'
  | 'confirmFacebookConnect'
  | 'connectedGoogle'
  | 'connectedFacebook'
  | null;

type Props = {|
  onComplete: () => void,
  onDismiss: () => void,
|};

type State = {|
  activeModal: ModalKey,
|};

export class CompromisedAccountNag extends React.Component<Props, State> {
  state = { activeModal: null };

  socialManager = SocialNetworkSettingsManager.instance();

  activateModal = (modalKey: ModalKey) => () => this.setState({ activeModal: modalKey });

  handleConnect = (network: 'facebook' | 'google') => () => {
    this.activateModal(null)();
    this.socialManager.handleConnect(network, true, {
      success: this.activateModal(network === 'google' ? 'connectedGoogle' : 'connectedFacebook'),
    });
  };

  handlePasswordChangeSuccessConfirm = () => {
    this.activateModal(null)();
    this.props.onComplete();
  };

  render() {
    const { onComplete, onDismiss } = this.props;
    const { activeModal } = this.state;
    let connectingTo;
    if (activeModal === 'confirmGoogleConnect' || activeModal === 'connectedGoogle') {
      connectingTo = 'google';
    } else if (activeModal === 'confirmFacebookConnect' || activeModal === 'connectedFacebook') {
      connectingTo = 'facebook';
    }
    return (
      <React.Fragment>
        <NagBanner
          onChangePassword={this.activateModal('changePassword')}
          onDismiss={onDismiss}
          onFacebookConnect={this.activateModal('confirmFacebookConnect')}
          onGoogleConnect={this.activateModal('confirmGoogleConnect')}
        />
        {activeModal === 'changePassword' && (
          <ConnectViewer>
            {(viewer: Viewer) => (
              <PasswordModal
                hasPassword={viewer.isAuth ? viewer.hasPassword : false}
                onHide={this.activateModal(null)}
                onPasswordForgotModal={this.activateModal('forgotPassword')}
                onSuccess={this.activateModal('changedPasswordSuccess')}
                username={viewer.isAuth ? viewer.username : ''}
              />
            )}
          </ConnectViewer>
        )}
        {activeModal === 'changedPasswordSuccess' && (
          <PasswordChangeSuccessModal onHide={this.handlePasswordChangeSuccessConfirm} />
        )}
        {activeModal === 'forgotPassword' && (
          <CheckEmailModal variant="changePassword" onHide={this.activateModal(null)} />
        )}
        {(activeModal === 'confirmGoogleConnect' || activeModal === 'confirmFacebookConnect') &&
          connectingTo && (
            <ConfirmErasePasswordModal
              connectType={connectingTo}
              onConfirm={this.handleConnect(connectingTo)}
              onHide={this.activateModal(null)}
            />
          )}
        {(activeModal === 'connectedGoogle' || activeModal === 'connectedFacebook') &&
          connectingTo && (
            <ConnectedAccountSuccessModal connectType={connectingTo} onConfirm={onComplete} />
          )}
      </React.Fragment>
    );
  }
}

export default CompromisedAccountNag;
